<template>
  <div class="allcity">
    <div class="city-select">
      <div class="currCity" @mouseenter="inHandle" @mouseleave="outHandle">
        <span>{{cityName}}</span>
        <i>
          <img class="moreCity" src="http://images.xdf.cn/cms20150819/zuixinban/images/xiala_gw.png?20190410" alt="">
        </i>
        <transition name="fade">
          <div class="cityList" v-show="cityListShow">
            <h3 class="back"><a target="_self" @click="goBackCurrCity">返回当前城市</a></h3>
            <div class="cityBox">
              <ul>
                <li v-for="(cityInfo, key) in cityList_L" :key="key">
                  <span class="letter">{{ key.toUpperCase() }}</span>
                  <a
                    v-for="(city, index) in cityInfo"
                    class="cityItem"
                    :key="index"
                    :cid="city.Id"
                    @click="selectCity(city.Id ,city.Name)"
                  >{{ city.Name }}</a>
                </li>
              </ul>
              <ul>
                <li v-for="(cityInfo, key) in cityList_R" :key="key">
                  <span class="letter">{{ key.toUpperCase() }}</span>
                  <a
                    v-for="(city, index) in cityInfo"
                    class="cityItem"
                    :key="index"
                    :cid="city.Id"
                    @click="selectCity(city.Id ,city.Name)"
                  >{{ city.Name }}</a>
                </li>
              </ul>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="search">
      <div class="search-input" style="position:relative">
        <input @keyup.13="soukechId" @keyup="getSearchTipList" type="text" name="" placeholder="请输入课程或班号..." v-model="searchVal" x-webkit-speech>
        <div class="hotKeyWords" v-if="!hotKeyWords">
          <a
            v-for="(hotKey, index) in hotKeyWordsList"
            :key="index"
            target="_blank"
            :href="`http://souke1.xdf.cn/Search.aspx?cid=${soukecityId}&kw=${hotKey.Keyword}&adpl=XDF_indexN_bj_hotword_1&adct=${hotKey.Keyword}`"
          >{{ hotKey.Keyword }}</a>
        </div>
        <div class="hotKeyWords" v-else>
          <a
            v-for="(hotKey, index) in hotKeyWords"
            :key="index"
            :href="hotKey.url"
          >{{ hotKey.title }}</a>
        </div>
        <div class="tips ac_results">
          <ul>
            <li v-for="(item,index) in searchTips" :key="`tip-${index}`">
              <a :href="`http://souke.xdf.cn/Search?cid=1&kw=${item}`" v-html="hightText(item)" target="_blank">{{hightText(item)}}</a>
            </li>
          </ul>
        </div>
      </div>
      <button class="search-btn" @click="soukechId">搜索</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getHotKeyWord,getSearchTips} from 'js/getSoukeData.js'
export default {
  name: 'Cityselect',
  props: ['cityList', 'cityList_L', 'cityList_R', 'hotKeyWords'],
  data () {
    return {
      hotKeyWordsList: [],
      cityListShow: false,
      searchVal: '',
      searchTips:[],
    }
  },
  computed: {
    cityId () {
      return this.$store.state.soukecityId
    },
    ...mapState(['soukecityId', 'cityName'])
  },
  watch: {
    cityId (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getHotKeys(newVal)
      }
      return newVal
    }
  },
  created () {
    let cid = this.$cookies.get('soukecityid')
    let cname = this.$cookies.get('cityName')
    this.$store.commit('selectCity', {cid, cname})
    this.getHotKeys(this.cityId)
  },
  methods: {
    inHandle () {
      this.cityListShow = true
    },
    outHandle () {
      this.cityListShow = false
    },
    selectCity (cid, cname) {
      this.$store.commit('selectCity', {cid, cname})
      this.$cookies.set('soukecityid', cid, '14d', '/', '.xdf.cn')
      this.$cookies.set('cityName', cname, '14d', '/', '.xdf.cn')
      this.outHandle()
      this.getHotKeys(cid)
    },
    goBackCurrCity () {
      let cid = this.$store.state.currCityId||this.$store.state.soukecityId
      let cname = this.$store.state.currCityName||this.$store.state.cityName
      this.$store.commit('selectCity', {cid, cname})
      this.$cookies.set('soukecityid', cid, '14d', '/', '.xdf.cn')
      this.$cookies.set('cityName', cname, '14d', '/', '.xdf.cn')
    },
    getHotKeys (cityId) {
      if (cityId !== null) {
        getHotKeyWord(cityId).then(res => {
          this.hotKeyWordsList = res.ResponseData.HotKeyWordList
        })
      }
    },
    getSearchTipList(){
      let cid = this.soukecityId || 1;
      getSearchTips(cid, this.searchVal).then(res => {
        this.searchTips=res.responseData;
      })
    },
    hightText(item){
      return item.replace(new RegExp(this.searchVal, 'g'), `<span style="color:#00B388">${this.searchVal}</span>`)
    },
    soukechId () {
      window.open(`http://souke1.xdf.cn/Search.aspx?cid=${this.soukecityId}&kw=${encodeURI(this.searchVal)}`)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.allcity
  flex: 1
  float:left
  .city-select
    vertically()
    padding: 0 8px
    float:left
    position: relative
    top: 5px
    width: 80px
    justify-content: left
    .currCity
      cursor: pointer
      z-index: 1
      color: #9f9f9f
      position: $rel
      z-index: 5
      .moreCity
        transition: transform 0.2s
      &:hover
        .moreCity
          transform: rotate(180deg)
      .cityList
        position: $abs
        font-size: 14px
        color: #606060
        top: 18px
        background: #fff
        border: 1px solid #e1e2e1
        text-align: left
        width: 745px
        padding: 10px 16px
        .back
          a
            line-height: 28px
            color: $themeColor
        .cityBox
          display: flex
          ul
            flex: 1
            li
              padding: 4px 6px 4px 14px
              position: relative
              .letter
                color: #369e95
                padding: 0 6px 0 2px
                font-family: Consolas
                position: absolute
                font-size: 14px
                left: 0
                top: 8px
              .cityItem
                padding: 0 4px
                margin: 0 2px
                line-height: 20px
                font-size: 12px
                border-radius: 6px
                color: #606060
                &:hover
                  background-color: $themeColor
                  color: $fontcolor
  .search
    height: 35px
    flex: 3
    margin-top: -6px
    float:left
    position: relative
    top: 6px
    left: 38px
    .search-input
      flex: 1
      position: $rel
      float:left
      input
        height: 26px
        width: 615px
        border:2px solid #00b388
        padding:3px 0 3px 10px
      .hotKeyWords
        position: $abs
        left: 0
        line-height: 28px
        font-size: 12px
        width: 750px
        a
          margin-right: 10px
          color: #9f9f9f
          &:hover
            color: $themeColor
      .tips
        position: absolute; 
        width:627px;
        background:rgba(255,255,255,1);
        box-shadow:0px 3px 5px 0px rgba(12,3,7,0.2);
        top: 36px; 
        left: 0px; 
        display: block;
        border-top:0px;
        z-index:999
        li
          margin: 0px;
          height 30px;
          box-sizing border-box
          line-height 30px;
          cursor: default;
          display: block;
          overflow: hidden;
          color: #666;
          a
            display block
            cursor pointer
            padding: 2px 12px;
            &:hover
              color:#00B388
              background-color: #f5f5f5;
    .search-btn
      width: 90px
      height:36px
      line-height: 36px
      float:left
      background: #00b388
      color: $fontcolor
      cursor: pointer
      &:hover
        opacity: .85
</style>



// WEBPACK FOOTER //
// src/common-components/Cityselect.vue